import React from "react";

function SvgUmbrella({
  color = "currentColor",
  width = 20,
  height = 20,
  ...props
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M19.6 21L13.25 14.65L14.65 13.25L21 19.6L19.6 21ZM5.95 20.3C4.95 19.3 4.20833 18.175 3.725 16.925C3.24167 15.675 3 14.4 3 13.1C3 11.8 3.24167 10.5333 3.725 9.29998C4.20833 8.06664 4.95 6.94998 5.95 5.94998C6.95 4.94998 8.07083 4.20414 9.3125 3.71248C10.5542 3.22081 11.825 2.97498 13.125 2.97498C14.425 2.97498 15.6958 3.22081 16.9375 3.71248C18.1792 4.20414 19.3 4.94998 20.3 5.94998L5.95 20.3ZM6.15 17.25L7.5 15.9C7.23333 15.55 6.97917 15.1916 6.7375 14.825C6.49583 14.4583 6.275 14.0916 6.075 13.725C5.875 13.3583 5.7 12.9916 5.55 12.625C5.4 12.2583 5.26667 11.9 5.15 11.55C4.96667 12.5333 4.95417 13.5166 5.1125 14.5C5.27083 15.4833 5.61667 16.4 6.15 17.25ZM8.95 14.5L14.5 8.89998C13.7833 8.34998 13.0625 7.90414 12.3375 7.56248C11.6125 7.22081 10.9333 6.98748 10.3 6.86248C9.66667 6.73748 9.09583 6.71664 8.5875 6.79998C8.07917 6.88331 7.68333 7.06664 7.4 7.34998C7.11667 7.64998 6.93333 8.05414 6.85 8.56248C6.76667 9.07081 6.7875 9.64581 6.9125 10.2875C7.0375 10.9291 7.27083 11.6083 7.6125 12.325C7.95417 13.0416 8.4 13.7666 8.95 14.5ZM15.9 7.49998L17.3 6.14998C16.4167 5.61664 15.4833 5.26664 14.5 5.09998C13.5167 4.93331 12.5333 4.94998 11.55 5.14998C11.9167 5.26664 12.2833 5.39998 12.65 5.54998C13.0167 5.69998 13.3833 5.87081 13.75 6.06248C14.1167 6.25414 14.4792 6.47081 14.8375 6.71248C15.1958 6.95414 15.55 7.21664 15.9 7.49998Z"
        fill={color}
      />
    </svg>
  );
}

export default SvgUmbrella;
